//import { formatJsonLocation as fjl, formatLocation } from "../../components/renderers";
//import { formatJsonDataset as fjd } from "../../components/renderers";
import {authbasic} from './authbasic';
import {corebasic} from './corebasic';
import {uiuxbasic} from './uiuxbasic';
import {mainbasic} from './mainbasic';
import {reportbasic} from './reportbasic';
import {uploadbasic} from './uploadbasic';
import {budgetbasic } from './budgetbasic';
import {apisbasic } from './apisbasic';
import {filebasic } from './filesbasic';
import {financebasic } from './financebasic';
import {eventsbasic } from './eventsbasic';
import {flowsbasic } from './flowsbasic';
import { formsbasic } from './formsbasic';
import { activitybasic } from './activitybasic';
import { kpibasic } from './kpisbasic';
import {biebasic} from './biebasic'

export const basicconfig = {
  ...authbasic,
  ...corebasic,
  ...uiuxbasic,
  ...mainbasic,
  ...reportbasic,
  ...budgetbasic,
  ...uploadbasic,
  ...apisbasic,
  ...kpibasic,
  ...filebasic,
  ...financebasic,
  ...eventsbasic,
  ...flowsbasic,
  ...formsbasic,
  ...activitybasic,
  ...biebasic
};
